import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Dbmodels } from '../../../../../core/entities/dbmodels.model';
import { Dbindices } from '../../../../../core/entities/dbindices.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsDbmodelsComponent } from './dialogs-dbmodels/edit-dialogs-dbmodels/edit-dialogs-dbmodels.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../../../../../core/utils/utils';
import { Router } from '@angular/router';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-dbmodels',
  templateUrl: './dbmodels.component.html',
  providers: [MessageService],
  styleUrls: ['./dbmodels.component.scss']
})
export class DbmodelsComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  dbmodel: Dbmodels = new Dbmodels();
  arraydbindice: Dbindices[] = new Array<Dbindices>();

  ruta = '/internal/home/dbindices';
  mensajeError: boolean = false;

  activeState: boolean[] = [true, false, false];

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private router: Router,
    private messageService: MessageService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllDbmodels();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla dbmodels
  */
  private getAllDbmodels(): void {

    this.loading = true;

    if (this.internalHomeService.chivato)
      this.internalHomeService.arrayDbmodels = [];
      this.internalHomeService.arrayDbindices = [];
      this.internalHomeService.viewDbattrs.info = true;
      this.internalHomeService.allDbmodels().subscribe(res => {
        console.log(res);
        this.loading = false;
      }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
      });
  }

  /**
  * @description
  * Abre el dialog para crear un dbmodel
  * @param dbmodel Opcional. Dbmodel vacio.
  */
  public createDbmodel(dbmodel?: Dbmodels) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = false;
    dbmodel = this.dbmodel;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbmodelsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbmodel, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbmodels();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un dbmodel
  * @param dbmodel Opcional. Dbmodel a editar.
  */
  public editDbmodel(dbmodel?: Dbmodels) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbmodelsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbmodel, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbmodels();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un dbmodel
  * @param dbmodel Dbmodel a eliminar
  */
  public removeDbmodel(dbmodel?: Dbmodels) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_dbmodels') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeDbmodels(dbmodel).subscribe(res => {
          console.log(res);
          this.getAllDbmodels();
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para visualizar el Dbmodel.
  * @param dbmodel Opcional. Dbmodel.
  */
  public viewDbmodel(dbmodel?: Dbmodels) {
    this.loading = true;
    this.internalHomeService.chivato = false;
    if(dbmodel){
      this.internalHomeService.viewDbmodels = dbmodel;
    }
    if(Utils.noUndfAndNull(this.internalHomeService.viewDbmodels)){
      this.router.navigate([this.ruta]);
      this.arraydbindice = this.internalHomeService.viewDbmodels.dbindices;
      this.internalHomeService.arrayDbindices = this.arraydbindice;
      console.log(this.internalHomeService.arrayDbindices);
      this.internalHomeService.allDbindices().subscribe(res => {
        console.log(res);
        this.internalHomeService.chivato = true;
        this.internalHomeService.viewDbmodels.info = false;
        this.loading = false;
      }, error => {
        this.loading = false;
        console.log("Error: " + error);
      });
    }
    this.loading = false;
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

  /**
  * Funcion para la gestión del texto desplegable (cerrar tab)
  * @param event evento a capturar.
  */
  onTabClose(event: any) {
    this.messageService.add({severity:'info', summary:'Tab Closed', detail: 'Index: ' + event.index})
  }

  /**
  * Funcion para la gestión del texto desplegable (abrir tab)
  * @param event evento a capturar.
  */
  onTabOpen(event: any) {
    this.messageService.add({severity:'info', summary:'Tab Expanded', detail: 'Index: ' + event.index});
  }

  /**
  * Funcion para la gestión del texto desplegable
  */
  toggle(index: number) {
    this.activeState[index] = !this.activeState[index];
  }

}
